
import React from 'react';
import data from '../../../utils/dbSchema';
import Layout from '../../Layout';
import { Box, Wrapper } from '../../UI';
import Meta from './Meta';
import PageTitle from '../../Layout/PageTitle';
import { Button, Divider } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import Fees from './Fees';
import Process from './Process';
import NavigateBack from '../../UI/NavigateBack';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';

export default function Dashboard({ match, history }) {
	const { path } = match;
	const propertyData = data.properties.find(property => {
		return match.params.id === property.id;
	});

	return (
		<Layout path={path} history={history}>
			<Box p="30px">
				<Wrapper>
                    <PageTitle title={`${propertyData.id} - ${propertyData.sell.address}`} action={<NavigateBack slug={`/my-portfolio`} />}>
						<Button variant="contained" color="defailt" startIcon={<EditIcon />} style={{marginRight: '1rem'}} component={Link} to={`/my-portfolio/${propertyData.id}`} >
							Edit
						</Button>
						<Button variant="contained" color="primary" startIcon={<CancelIcon />}>
							Deactivate
						</Button>
					</PageTitle>
                    <Meta />
            		<Divider style={{margin: '2rem 0'}} />
					<Fees />
            		<Divider style={{margin: '2rem 0'}} />
					<Process propertyId={propertyData.id}/>
				</Wrapper>
			</Box>
		</Layout>
	);
}
